export const createSrcSet = (src: string, widthSet: number[], ratio: number): string =>
    widthSet.reduce(
        (acc, sourceSetWidth) => acc + `${createSrcWithSizes(src, sourceSetWidth, ratio)} ${sourceSetWidth}w,`,
        ''
    );

export const createSrcWithSizes = (src: string, sourceSetWidth: number, ratio: number): string => {
    const height = Math.round(sourceSetWidth / ratio);

    return `${src}&width=${sourceSetWidth}&height=${height}`;
};
